export const DataMutation_ShippingMemberSetAuthorityToLeave_QueryKey = {
  shippingMemberSetAuthorityToLeave: (): string => {
    const queryKey = "data-mutation--shipping-member-set-authority-to-leave";
    return queryKey;
  },
};
